import { useMemo, useState, useEffect } from 'react';

interface AvatarProps {
  nome: string;
  fotoUrl?: string | null;
  tamanho?: number;
  className?: string;
  // Ampliar ao clicar. So' vale quando ha FOTO NA TELA: se a URL falhou (pps.whatsapp.net
  // expira) o componente ja caiu nas iniciais, e ai nao ha o que ampliar — o clique morre
  // junto, em vez de abrir um quadro quebrado.
  onFotoClick?: () => void;
}

const PALETA = [
  '#ef4444', '#f97316', '#f59e0b', '#84cc16', '#10b981',
  '#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6', '#d946ef',
];

function hashCor(s: string): string {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETA[h % PALETA.length]!;
}

function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/);
  if (partes.length === 0 || !partes[0]) return '?';
  if (partes.length === 1) return partes[0]!.slice(0, 2).toUpperCase();
  return ((partes[0]!.charAt(0)) + (partes[partes.length - 1]!.charAt(0))).toUpperCase();
}

export function Avatar({ nome, fotoUrl, tamanho = 36, className = '', onFotoClick }: AvatarProps) {
  const cor = useMemo(() => hashCor(nome || '?'), [nome]);
  const txt = useMemo(() => iniciais(nome || '?'), [nome]);
  const [erroFoto, setErroFoto] = useState(false);
  // pps.whatsapp.net expira; reseta o erro quando muda a URL
  useEffect(() => { setErroFoto(false); }, [fotoUrl]);

  const usarFoto = fotoUrl && !erroFoto;
  const style = {
    width: tamanho,
    height: tamanho,
    fontSize: Math.round(tamanho * 0.4),
    backgroundColor: usarFoto ? 'transparent' : cor,
  };
  if (usarFoto) {
    const img = <img src={fotoUrl} alt={nome} className={`avatar ${className}`} style={style} onError={() => setErroFoto(true)} />;
    if (!onFotoClick) return img;
    return (
      <button
        type="button"
        // A linha da tabela costuma ter acao propria (selecionar, e no duplo-clique abrir o
        // registro): o clique da foto para AQUI e nao vira gesto na linha.
        onClick={(e) => { e.stopPropagation(); onFotoClick(); }}
        onDoubleClick={(e) => e.stopPropagation()}
        title={`Ver a foto de ${nome}`}
        aria-label={`Ampliar a foto de ${nome}`}
        style={{ padding: 0, border: 0, background: 'transparent', cursor: 'zoom-in', lineHeight: 0, display: 'inline-block' }}
      >
        {img}
      </button>
    );
  }
  return <div className={`avatar ${className}`} style={style}>{txt}</div>;
}
